module.exports = __webpack_public_path__ + "img/user.8bc74ec3.svg";